import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCurrentPage } from "../reducers/generalSlice";

export default function Title({ title, page }) {
  const dispatch = useDispatch()
  useEffect(() => {
    document.title = title + " - AK API - Unofficial Facebook Graph API";
  }, [title]);
  useEffect(() => {
    dispatch(setCurrentPage(page));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return null;
}